export default __webpack_public_path__ + "static/media/MATHEMATICS_GEOMETRY.d62e8ccb.svg";